namespace GeniuzPOS.InventoryReport {
    export class IcReport01_VColumns {
        static columnsKey = 'InventoryReport.IcReport01_V';
    }
}
